//import { authGuard } from "../auth";

//Lazy Load:      const Foo = () => import('./Foo.vue')
//Dynamic Load:   import foo from '.Foo.vue'
/////////////////////////////////////////////////////////////////////////

// PORTAL IMPORTS
const PortalLayout = () => import("@/pages/Portal/Layout/PortalLayout.vue")

//VIDEOCHAT PATIENT COMPONENT
// const Telemedicine        = () => import('@/pages/Portal/Views/Telemedicine.vue')

// SUPER ADMIN
const superAdminLayout = () => import("@/pages/Portal/Views/SuperAdmin/Layout/SuperAdminLayout.vue")
const superAdminSiViewConfig = () => import("@/pages/Portal/Views/SuperAdmin/Pages/SiViewConfig.vue")
const superAdminGlobes = () => import("@/pages/Portal/Views/SuperAdmin/Pages/mgmtGlobes.vue")
const superAdminClients = () => import("@/pages/Portal/Views/SuperAdmin/Pages/mgmtClients.vue")
const superAdminMasterData = () => import("@/pages/Portal/Views/SuperAdmin/Pages/mgmtMasterData.vue")

// ADMIN
const AdminLayout = () => import("@/pages/Portal/Views/Admin/Layout/AdminLayout.vue")
const adminDashboard = () => import("@/pages/Portal/Views/Admin/Pages/Dashboard.vue")
const adminScreenings = () => import("@/pages/Portal/Views/Admin/Pages/Screenings.vue")
const adminOnhold = () => import("@/pages/Portal/Views/Admin/Pages/Onhold.vue")
const adminReports = () => import("@/pages/Portal/Views/Reader/Pages/Reports.vue")
const adminReportsAging = () => import("@/pages/Portal/Views/Admin/Pages/ReportsAging.vue")
const adminReportViewer = () => import("@/pages/Portal/Views/Common/Pages/ReportViewer.vue")

const adminSettings = () => import("@/pages/Portal/Views/Admin/Pages/mgmtSettings.vue")
const adminLists = () => import("@/pages/Portal/Views/Admin/Pages/mgmtLists.vue")
const adminContent = () => import("@/pages/Portal/Views/Admin/Pages/mgmtContent.vue")
const adminUsers = () => import("@/pages/Portal/Views/Admin/Pages/mgmtUsers.vue")
const adminPatients = () => import("@/pages/Portal/Views/Admin/Pages/mgmtPatients.vue")
const adminCPT = () => import("@/pages/Portal/Views/Admin/Pages/mgmtCPT.vue")

const adminDoctorsDetail = () => import("@/pages/Portal/Views/Admin/Pages/DoctorsDetail.vue")
const adminDoctorsList = () => import("@/pages/Portal/Views/Admin/Pages/DoctorsList.vue")
const adminDoctorsPending = () => import("@/pages/Portal/Views/Admin/Pages/DoctorsPending.vue")
const adminDoctorsPractice = () => import("@/pages/Portal/Views/Admin/Pages/DoctorsPractice.vue")
const adminDoctorsSearch = () => import("@/pages/Portal/Views/Admin/Pages/DoctorsSearch.vue")

// TECHNICIAN
const TechnicianLayout = () => import("@/pages/Portal/Views/Technician/Layout/TechnicianLayout.vue")
const technicianDashboard = () => import("@/pages/Portal/Views/Technician/Pages/Dashboard.vue")
const technicianScreenings = () => import("@/pages/Portal/Views/Technician/Pages/Screenings.vue")
const technicianOnhold = () => import("@/pages/Portal/Views/Technician/Pages/Onhold.vue")
const technicianReportViewer = () => import("@/pages/Portal/Views/Common/Pages/ReportViewer.vue")
const technicianEvalViewOnly = () => import("@/pages/Portal/Views/Technician/Pages/EvalViewOnly.vue")
const adminDoctors = () => import("@/pages/Portal/Views/Admin/Pages/mgmtDoctors.vue")

// READER
import readerDashboard from "@/pages/Portal/Views/Reader/Pages/Dashboard.vue"
import readerScreenings from "@/pages/Portal/Views/Reader/Pages/Screenings.vue"
const readerPatients = () => import("@/pages/Portal/Views/Reader/Pages/Patients.vue")
const readerPatient = () => import("@/pages/Portal/Views/Reader/Pages/PatientViewer.vue")
const ReaderLayout = () => import("@/pages/Portal/Views/Reader/Layout/ReaderLayout.vue")
const readerMessages = () => import("@/pages/Portal/Views/Reader/Pages/Messages.vue")
const readerEvaluation = () => import("@/pages/Portal/Views/Reader/Pages/Evaluation.vue")
const readerReportPreview = () => import("@/pages/Portal/Views/Reader/Pages/ReportPreview.vue")
const readerOnhold = () => import("@/pages/Portal/Views/Reader/Pages/Onhold.vue")
const readerReports = () => import("@/pages/Portal/Views/Reader/Pages/Reports.vue")
const readerReportViewer = () => import("@/pages/Portal/Views/Common/Pages/ReportViewer.vue")
const readerDxCards = () => import("@/pages/Portal/Views/Reader/Pages/DxCardsV2.vue")
const readerSiViewV2 = () => import("@/pages/Portal/Views/Reader/Pages/SiViewV2.vue")
const readerPackagesV2 = () => import("@/pages/Portal/Views/Reader/Pages/PackagesV2.vue")
const readerDoctorProfile = () => import("@/pages/Portal/Views/Doctor/Pages/Profile.vue")
const readerBilling = () => import("@/pages/Portal/Views/Reader/Pages/Billing.vue")

// const readerTelemedicine = () => import('@/pages/Portal/Views/Reader/Pages/Telemedicine.vue')
// const readerAppointments = () => import('@/pages/Portal/Views/Reader/Pages/Appointments.vue')

const MemberLayout = () => import("@/pages/Portal/Views/Member/Layout/MemberLayout.vue")
const memberDashboard = () => import("@/pages/Portal/Views/Member/Pages/Dashboard.vue")
const memberMessages = () => import("@/pages/Portal/Views/Member/Pages/Messages.vue")
const memberReports = () => import("@/pages/Portal/Views/Member/Pages/Reports.vue")
const memberReportViewer = () => import("@/pages/Portal/Views/Common/Pages/ReportViewer.vue")
const memberReferrals = () => import("@/pages/Portal/Views/Member/Pages/Referrals.vue")
const memberHistory = () => import("@/pages/Portal/Views/Member/Pages/History.vue")

const DoctorLayout = () => import("@/pages/Portal/Views/Doctor/Layout/DoctorLayout.vue")
const doctorDashboard = () => import("@/pages/Portal/Views/Doctor/Pages/Dashboard.vue")
const doctorProfile = () => import("@/pages/Portal/Views/Doctor/Pages/Profile.vue")
const doctorReports = () => import("@/pages/Portal/Views/Doctor/Pages/Reports.vue")
const doctorReferrals = () => import("@/pages/Portal/Views/Doctor/Pages/Referrals.vue")

import mySettings from "@/pages/Portal/Views/Member/Pages/Settings/MySettings.vue"

/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////
// AUTH IMPORTS
import AuthLayout from "@/pages/Auth/Layout/AuthLayout.vue"
import Login from "@/pages/Auth/Login.vue"
import GCRegister from "@/pages/Auth/GCRegister.vue"
import RegisterDoctor from "@/pages/Auth/RegisterDoctor.vue"
import RegisterPatient from "@/pages/Auth/RegisterPatient.vue"
import Lock from "@/pages/Auth/Lock.vue"

const ResetPsw = () => import("@/pages/Auth/ResetPsw.vue")
const ResetPswAction = () => import("@/pages/Auth/ResetPswAction.vue")
const SetPswAction = () => import("@/pages/Auth/SetPswAction.vue")
const DoctorSearch = () => import("@/pages/Auth/DoctorSearch.vue")
const ReadingCenter = () => import("@/pages/Auth/ReadingCenter.vue")
const Pricing = () => import("@/pages/Auth/Pricing.vue")

// const ReportCreation = () =>
//   import("@/components/GlobeChek/screening/ReportCreation.vue");

let authPages = {
  path: "/",
  name: "Authentication",
  meta: { roles: [] },
  component: AuthLayout,
  children: [
    {
      path: "/reading-center",
      name: "Reading Center",
      component: ReadingCenter
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/reset-psw",
      name: "ResetPsw",
      component: ResetPsw
    },
    {
      path: "/reset-psw-action",
      name: "ResetPswAction",
      component: ResetPswAction
    },
    {
      path: "/set-psw-action",
      name: "SetPswAction",
      component: SetPswAction
    },
    {
      path: "/doctor-search",
      name: "DoctorSearch",
      component: DoctorSearch
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },
    {
      path: "/gc-register",
      name: "GCRegister",
      component: GCRegister
    },
    {
      path: "/register-doctor",
      name: "Doctor Registration",
      component: RegisterDoctor
    },
    {
      path: "/register-patient",
      name: "Patient Registration",
      component: RegisterPatient
    },
    {
      path: "/search-doctors",
      name: "Search Doctors",
      component: ReadingCenter
    },

    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    }
  ]
}

//////////////////////////////////////////////////////////////
// START - PORTAL ROUTES
let portalMenu = {
  path: "/portal",
  component: PortalLayout,
  name: "Portal",
  children: []
}

let readerMenu = {
  path: "/portal/reader",
  component: ReaderLayout,
  name: "Reader",
  meta: { roles: ["Reader"] },
  redirect: "/portal/reader/dashboard",
  children: [
    {
      path: "dashboard",
      name: "Reader Dashboard",
      component: readerDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "messages",
      name: "Reader Messages",
      component: memberMessages,
      meta: { requiresAuth: true }
    },
    {
      path: "patients",
      name: "Reader Patients",
      component: readerPatients,
      meta: { requiresAuth: true }
    },
    {
      path: "patient",
      name: "Reader Patient",
      component: readerPatient,
      meta: { requiresAuth: true }
    },
    {
      path: "screenings",
      name: "Reader: Screenings",
      component: readerScreenings,
      meta: { requiresAuth: true }
    },
    {
      path: "evaluation",
      name: "Screening Evaluation",
      component: readerEvaluation,
      meta: { requiresAuth: true }
    },
    {
      path: "preview",
      name: "Report Preview",
      component: readerReportPreview,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: "onhold",
      name: "Evaluations On-Hold",
      component: readerOnhold,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "Generated Reports",
      component: readerReports,
      meta: { requiresAuth: true }
    },
    {
      path: "report",
      name: "Report Viewer",
      component: readerReportViewer,
      meta: { requiresAuth: true }
    },
    {
      path: "doctors-list",
      name: "Reader: List Doctors",
      component: adminDoctorsList,
      meta: { requiresAuth: true }
    },
    {
      path: "dxcards",
      name: "Dx Cards",
      component: readerDxCards,
      meta: { requiresAuth: true }
    },
    {
      path: "packages",
      name: "Ingest Packages",
      // component: readerPackages,
      component: readerPackagesV2,
      meta: { requiresAuth: true }
    },
    {
      path: "siview",
      name: "SiVIEW EMR",
      // component: readerSiView,
      component: readerSiViewV2,
      meta: { requiresAuth: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true }
    },
    {
      path: "doctor/profile",
      name: "Doctor Profile",
      component: readerDoctorProfile,
      meta: { requiresAuth: true }
    }
    /*
    {
      path: "telemedicine",
      name: "Telemedicine",
      component: readerTelemedicine
      meta: {requiresAuth: true}
    },
    {
      path: "appointments",
      name: "Appointments",
      component: readerAppointments
      meta: {requiresAuth: true}
    }
    */
  ]
}

let memberMenu = {
  path: "/portal/member",
  component: MemberLayout,
  name: "Member",
  meta: { roles: ["Patient"] },
  redirect: "/portal/member/dashboard",
  children: [
    {
      path: "dashboard",
      name: "Member Dashboard",
      component: memberDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "messages",
      name: "Member Messages",
      component: memberMessages,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "My Screening Reports",
      component: memberReports,
      meta: { requiresAuth: true }
    },

    {
      path: "report",
      name: "My Screening Report",
      component: memberReportViewer,
      meta: { requiresAuth: true }
    },
    {
      path: "referrals",
      name: "Referrals",
      component: memberReferrals,
      meta: { requiresAuth: true }
    },
    {
      path: "history",
      name: "Vision History",
      component: memberHistory,
      meta: { requiresAuth: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true }
    }
  ]
}

let doctorMenu = {
  path: "/portal/doctor",
  component: DoctorLayout,
  name: "Doctor",
  meta: { roles: ["Doctor"] },
  redirect: "/portal/doctor/dashboard",
  children: [
    {
      path: "dashboard",
      name: "Doctor Dashboard",
      component: doctorDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "profile",
      name: "Doctor Profile",
      component: doctorProfile,
      meta: { requiresAuth: true }
    },
    {
      path: "messages",
      name: "Doctor Messages",
      component: memberMessages,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "Doctor Reports",
      component: doctorReports,
      meta: { requiresAuth: true }
    },
    {
      path: "referrals",
      name: "Doctor Referrals",
      component: doctorReferrals,
      meta: { requiresAuth: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true }
    }
  ]
}

let adminMenu = {
  path: "/portal/admin",
  component: AdminLayout,
  name: "Admin",
  meta: { roles: ["Administrator", "Super"] },
  redirect: "/portal/admin/dashboard",
  children: [
     {
      path: "cpts",
      name: "Admin: CPT",
      component: adminCPT,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "billing",
      name: "Billing",
      component: readerBilling,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "dashboard",
      name: "Admin Dashboard",
      component: adminDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "messages",
      name: "Admin: Messages",
      component: memberMessages,
      meta: { requiresAuth: true }
    },
    {
      path: "patients-list",
      name: "Admin: Patient",
      component: readerPatients,
      meta: { requiresAuth: true }
    },
    {
      path: "patient",
      name: "Admin: Patients",
      component: readerPatient,
      meta: { requiresAuth: true }
    },
    {
      path: "screenings",
      name: "Admin: Screenings",
      component: readerScreenings,
      meta: { requiresAuth: true }
    },
    // {
    //   path: "evalviewonly",
    //   name: "Admin: Screening Evaluation (View Only)",
    //   component: adminEvalViewOnly,
    //   meta: { requiresAuth: true }
    // },
    {
      path: "evaluation",
      name: "Screening Evaluation",
      component: technicianEvalViewOnly,
      meta: { requiresAuth: true }
    },
    {
      path: "onhold",
      name: "Admin: Screenings On Hold (ALL)",
      component: readerOnhold,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "Admin: Generated Reports (ALL)",
      component: adminReports,
      meta: { requiresAuth: true }
    },
    {
      path: "reports-aging",
      name: "Admin: Aging Reports (ALL)",
      component: adminReportsAging,
      meta: { requiresAuth: true }
    },
    {
      path: "report",
      name: "Admin: Report Viewer",
      component: adminReportViewer,
      meta: { requiresAuth: true }
    },
    {
      path: "packages",
      name: "Admin: Package Ingest Monitor",
      // component: adminPackages,
      component: readerPackagesV2,
      meta: { requiresAuth: true }
    },
    {
      path: "doctor-detail/:id",
      name: "Admin: Doctor Detail",
      component: adminDoctorsDetail,
      meta: { requiresAuth: true }
    },
    {
      path: "doctors-list",
      name: "Admin: List Doctors",
      component: adminDoctorsList,
      meta: { requiresAuth: true }
    },
    {
      path: "doctors-pending",
      name: "Admin: Doctors Pending Approval",
      component: adminDoctorsPending,
      meta: { requiresAuth: true }
    },
    {
      path: "practices-list",
      name: "Admin: List Practices",
      component: adminDoctorsPractice,
      meta: { requiresAuth: true }
    },
    {
      path: "doctor-search",
      name: "Admin: Search Doctors",
      component: adminDoctorsSearch,
      meta: { requiresAuth: true }
    },
    {
      path: "users",
      name: "Admin: Users Management",
      component: adminUsers,
      meta: { requiresAuth: true }
    },
    {
      path: "patients",
      name: "Admin: Patients Management",
      component: adminPatients,
      meta: { requiresAuth: true }
    },
    {
      path: "dxcards",
      name: "Dx Cards",
      component: readerDxCards,
      meta: { requiresAuth: true }
    },
    {
      path: "settings",
      name: "Admin: Settings Management",
      component: adminSettings,
      meta: { requiresAuth: false }
    },
    {
      path: "lists",
      name: "Admin: List Management",
      component: adminLists,
      meta: { requiresAuth: true }
    },
    {
      path: "content",
      name: "Admin: Content Management",
      component: adminContent,
      meta: { requiresAuth: true }
    },
    {
      path: "doctors",
      name: "Admin: Doctors Management",
      component: adminDoctors,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true }
    },
    {
      path: "siview",
      name: "SiVIEW EMR",
      // component: readerSiView,
      component: readerSiViewV2,
      meta: { requiresAuth: true }
    }
  ]
}

let superAdminMenu = {
  path: "/portal/super-admin",
  component: superAdminLayout,
  name: "Super-admin",
  meta: { roles: ["Super"] },
  redirect: "/portal/super-admin/siview-config",
  children: [
    {
      path: "messages",
      name: "Super Admin: Messages",
      component: memberMessages,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "siview-config",
      alias: "siview-config/dashboard",
      name: "SiView Config",
      component: superAdminSiViewConfig,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "clients",
      name: "Super Admin: Clients",
      component: superAdminClients,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "globes",
      name: "Super Admin: Globe Management",
      component: superAdminGlobes,
      meta: { requiresAuth: true }
    },
    {
      path: "master-data",
      name: "Super Admin: Master Data",
      component: superAdminMasterData,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "users",
      name: "Super Admin: Users Management",
      component: adminUsers,
      meta: { requiresAuth: true }
    },
    {
      path: "cpts",
      name: "Super Admin: CPT",
      component: adminCPT,
      meta: { requiresAuth: true }
    }
  ]
}

let technicianMenu = {
  path: "/portal/technician",
  component: TechnicianLayout,
  name: "Technician",
  meta: { roles: ["Technician"] },
  redirect: "/portal/technician/dashboard",
  children: [
     {
      path: "billing",
      name: "Billing",
      component: readerBilling,
      meta: { requiresAuth: true }
    },
    {
      path: "dashboard",
      name: "Technician Dashboard",
      component: technicianDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "messages",
      name: "Technician: Messages",
      component: memberMessages,
      meta: { requiresAuth: true }
    },
    {
      path: "packages",
      name: "Technician: Package Ingest Monitor",
      component: readerPackagesV2,
      meta: { requiresAuth: true }
    },
    {
      path: "patients",
      name: "Technician: Patients",
      component: readerPatients,
      meta: { requiresAuth: true }
    },
    {
      path: "patient",
      name: "Technician: Patient",
      component: readerPatient,
      meta: { requiresAuth: true }
    },
    {
      path: "screenings",
      name: "Technician: Screenings",
      component: readerScreenings,
      meta: { requiresAuth: true }
    },
    {
      path: "Onhold",
      name: "Technician: Evaluations On-Hold",
      component: readerOnhold,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "Technician: Generated Reports (ALL)",
      component: readerReports,
      meta: { requiresAuth: true }
    },
    {
      path: "evaluation",
      name: "Technician: Screening Evaluation (View Only)",
      component: technicianEvalViewOnly,
      meta: { requiresAuth: true }
    },
    {
      path: "report",
      name: "Technician: Report Viewer",
      component: technicianReportViewer,
      meta: { requiresAuth: true }
    },
    {
      path: "siview",
      name: "Technician: SiVIEW EMR",
      component: readerSiViewV2,
      meta: { requiresAuth: true }
    },
    {
      path: "my-settings",
      name: "My Settings",
      component: mySettings,
      meta: { requiresAuth: true }
    }
  ]
}
/*
let telemedicine = {
  path: "/telemedicine/:room",
  component: Telemedicine,
  name: "Telemedicine",
  meta: {requiresAuth: true}
};
*/

// END - PORTAL ROUTES
//////////////////////////////////////////////////////////////

const routes = [
  {
    path: "/",
    redirect: "/reading-center",
    name: "Home"
  },
  authPages,
  portalMenu,
  readerMenu,
  doctorMenu,
  memberMenu,
  adminMenu,
  superAdminMenu,
  technicianMenu
  // telemedicine,
]

export default routes
